import * as LogoDL from '../DL/Logo';

export const GetLogoConfig = async () => {
    return await LogoDL.GetLogoConfig();
};

export const SetLogoConfig = async (config) => {
    return await LogoDL.SetLogoConfig(config);
};

export const ToggleLogoVisibility = async (visible) => {
    return await LogoDL.ToggleLogoVisibility(visible);
};
